<div class="single-window__layout" [ngClass]="{'single-window__layout_visible': opened}">
  <a class="single-window__close icon icon_delete_sign" href="javascript:void(0)" (click)="closeWindow()"></a>
  <div class="single-window__layout__wrapper" #wrapper>

    <div class="single-window__wrapper">
      <ng-template #componentContainer></ng-template>
    </div>
  </div>
</div>
